const navigationBar = {
  equipmentList: "Ausrüstungsliste",
  inspectionList: "Liste der Betriebsprüfungprotokollen",
  reliability: "Inspektionen Zuverlässigkeit",
  repairList: "Liste der Reparaturprotokolle",
  new: "Neu",
  equipment: "Ausrüstung",
  equipmentType: "Ausstattungsart",
  user: "Benutzer",
  customer: "Kunde",
  unit: "Einheit",
  company: "Firmenstruktur",
  area: "Bereich",
  logs: "Warnungen",
  sealTypes: "Dichtungstypen",
  hazardous: "Gefährliches Gelände",
  userList: "Benutzerliste",
  userProfile: "Benutzerprofil",
  signOut: "Ausloggen"
};
export default navigationBar;
